import styled from 'styled-components';

const CaseResultDiv = styled.div`
  width: 100%;
`;

CaseResultDiv.displayName = 'CaseResultDiv';

export default CaseResultDiv;
